module.exports = __webpack_public_path__ + "static/media/cr.55253c7c.jpeg";